// extracted by mini-css-extract-plugin
export default {"SocialMedia":"SocialMedia_SocialMedia__l-sh+"};